export const WHOLESALE_ELIGIBLE_VERTICALS = new Set([
    'Apparel & Footwear',
    'Fashion & Apparel',
    'Fashion & Clothing',
    'Footwear',
]);
export const WHOLESALE_ELIGIBLE_SEGMENTS = new Set([
    'Fashion/Apparel Retailing',
    'Footwear Retailing',
]);
